const API_URL = `${process.env.REACT_APP_API_URL}`;

export const obtenerArchivosDatos = async () => {
    try {
        const respuesta = await fetch(API_URL + "obtener_archivos.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
            }),
        });
  
        if (respuesta.ok) {

            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}

export const obtenerArchivosDian = async () => {
    try {
        const respuesta = await fetch(API_URL + "obtener_archivos_dian.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
            }),
        });
        
        if (respuesta.ok) {

            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}

export const subirArchivosDatos = async (archivo) => {
    try {

        const formData = new FormData();
        formData.append("archivo", archivo); // Clave "archivo" debe coincidir con la del backend

        const respuesta = await fetch(API_URL + "subir_archivo.php", {
            method: "POST",
            body: formData, // FormData se envía sin necesidad de headers
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}

export const subirArchivosDian = async (archivo) => {
    try {
        // Verifica que el archivo no sea null o undefined
        if (!archivo) {
            throw new Error("No se seleccionó ningún archivo.");
        }

        const formData = new FormData();
        formData.append("archivo", archivo); // Clave "archivo" debe coincidir con la del backend

        const respuesta = await fetch(API_URL + "subir_archivo_dian.php", {
            method: "POST",
            body: formData, // FormData se envía sin necesidad de headers
        });


        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        console.error("Error al subir el archivo:", error.message);
        throw new Error("Error al conectar con el servidor.");
    }
};
